import React from "react";

import {
  Breakpoints,
  CTA,
  TextAppearance,
  TextColor,
  TextCustom,
  TextLineHeight,
  TextSize,
  TextWeight,
} from "@vw-marketing/us-components";
import { Emphasis } from "@volkswagen-onehub/components-core/dist-es/call-to-action/index.mjs";

import { StyledIconCtaContainer } from "./styles";

interface IconCtaProps {
  ariaLabel?: string;
  disabled?: boolean;
  icon: React.ReactElement;
  label?: string;
  emphasis?: Emphasis;

  onClick?: () => void;
}

export const IconCta = ({
  ariaLabel,
  disabled,
  icon,
  label,
  onClick,
  emphasis = 'secondary'
}: IconCtaProps) => {
  return (
    <StyledIconCtaContainer>
      <CTA
        tag="button"
        emphasis={emphasis}
        aria-label={ariaLabel || "Icon CTA"}
        icon={icon}
        onClick={onClick}
        disabled={disabled}
      />
      <TextCustom
        appearance={TextAppearance.copy200}
        style={{
          [Breakpoints.default]: {
            fontSize: TextSize.TextSize14,
            fontWeight: TextWeight.light,
            color: TextColor.primary,
            lineHeight: TextLineHeight.TextLineHeight24,
          },
          [Breakpoints.b1600]: {
            fontSize: TextSize.TextSize16,
          },
        }}
      >
        {label}
      </TextCustom>
    </StyledIconCtaContainer>
  );
};
